import { Mail, Phone, MapPin, Facebook, Instagram } from 'lucide-react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../contexts/LanguageContext';
import { translations } from '../translations';

const Footer = () => {
  const { language } = useLanguage();
  const t = translations[language];

  return (
    <footer className="footer-tereka">
      <div className="footer-container">
        <div className="footer-grid">
          {/* About Section */}
          <div className="footer-section">
            <h3 className="footer-title">TEREKA</h3>
            <p className="footer-description">
              {t.footer.description}
            </p>
            <div className="social-links">
              <a href="#" className="social-link" aria-label="Facebook">
                <Facebook size={20} />
              </a>
              <a href="#" className="social-link" aria-label="Instagram">
                <Instagram size={20} />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div className="footer-section">
            <h4 className="footer-subtitle">{t.footer.navigation}</h4>
            <ul className="footer-links">
              <li><Link to="/">{t.nav.home}</Link></li>
              <li><Link to="/qui-sommes-nous">{t.nav.about}</Link></li>
              <li><Link to="/programme">{t.nav.program}</Link></li>
              <li><Link to="/contact">{t.nav.contact}</Link></li>
            </ul>
          </div>

          {/* Contact Info */}
          <div className="footer-section">
            <h4 className="footer-subtitle">{t.footer.contactTitle}</h4>
            <ul className="footer-contact">
              <li>
                <MapPin size={16} />
                <span>{t.contact.addressText}</span>
              </li>
              <li>
                <Mail size={16} />
                <span>contact@tereka.fr</span>
              </li>
              <li>
                <Phone size={16} />
                <span>+33 X XX XX XX XX</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="footer-bottom">
          <p>&copy; {new Date().getFullYear()} TEREKA. {t.footer.rights}</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;